import React from 'react';
import { Icon } from '@scp/ui-shared/theme/icons';
import { matchXLSMimeType, matchDOCMimeType, matchPPTMimeType, matchPDFMimeType, matchJPGMimeType, matchPNGMimeType, matchGIFMimeType } from './mimeTypeValidators';
export var FileIcon = function FileIcon(_ref) {
  var mimeType = _ref.mimeType,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      color = _ref.color;

  if (matchPDFMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-pdf",
      size: size,
      color: color || '#c90406'
    });
  }

  if (matchDOCMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-doc",
      size: size,
      color: color || '#2b569a'
    });
  }

  if (matchXLSMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-xls",
      size: size,
      color: color || '#207245'
    });
  }

  if (matchPPTMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-ppt",
      size: size,
      color: color || '#207245'
    });
  }

  if (matchJPGMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-jpg",
      size: size,
      color: color
    });
  }

  if (matchPNGMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-png",
      size: size,
      color: color
    });
  }

  if (matchGIFMimeType(mimeType)) {
    return React.createElement(Icon, {
      name: "file-gif",
      size: size,
      color: color
    });
  }

  return React.createElement(Icon, {
    name: "file-generic",
    size: size,
    color: color || '#b6bf00'
  });
};